/** Listen eines Bereichs auf seinem Board (F-33, Leitlinie 5) - mit offenen Eintraegen. */
import { Link } from 'react-router-dom';

import { statistik } from '@/domain/listen/listen';
import { ListenSymbol } from '@/modules/listen/ListenSymbol';
import { useAlleListen, useEintraegeJeListe } from '@/modules/listen/useListen';
import type { ID } from '@/domain/types';

export function BereichListen({ areaId }: { areaId: ID }) {
  const listen = (useAlleListen() ?? []).filter((l) => l.areaId === areaId && !l.archiviert);
  const jeListe = useEintraegeJeListe();
  return (
    <section aria-label="Listen" className="flex flex-col gap-2 rounded-lg border border-line bg-surface px-4 py-3.5">
      <h2 className="text-sm font-semibold">Listen</h2>
      {listen.length === 0
        ? <p className="text-sm text-ink-faint">Keine Listen in diesem Bereich – unter <Link to="/listen" className="text-accent-text hover:underline">Listen</Link> zuordnen.</p>
        : (
          <ul className="flex flex-col gap-1">
            {listen.map((l) => {
              const s = statistik(jeListe.get(l.id) ?? []);
              return (
                <li key={l.id}>
                  <Link to={`/listen/${l.id}`} className="flex items-center gap-2 rounded-md px-1 py-1 text-sm hover:bg-surface-raised">
                    <span style={{ color: l.farbe }}><ListenSymbol symbol={l.symbol} className="size-4" /></span>
                    <span className="min-w-0 flex-1 truncate">{l.name}</span>
                    <span className="text-[12px] tabular-nums text-ink-muted">{s.offen} offen</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
    </section>
  );
}
